/**
 * Bulk Upload User Interfaces
 */

export interface BatchFile {
  id: number;
  created_date: string;
  uploaded_count: number;
  rejected_count: number;
  batch_status: number; // 1=Pending, 2=Completed, 3=Rejected
  uploaded_fileurl?: string;
  rejected_data?: string; // JSON string of rejected records
}

export interface BulkUploadFormData {
  program_id: number;
  role_id: number;
  csv_file: File;
}

export interface DownloadExcelHeader {
  headers: string[];
  message: string;
}

export interface BatchFileApiResponse {
  data: BatchFile[];
  status: number;
}

export interface DownloadExcelApiResponse {
  data: DownloadExcelHeader;
  status: number;
}

export interface BulkUploadApiResponse {
  data: {
    response: string;
  };
  status: number;
}
